;(() => {
  const COLLECTION_SELECTOR =
    'input[name="front_order_line_item[collection_id]"]'
  const MODEL_SELECTOR =
    'input[name="front_order_line_item[front_attributes][model_id]"]'
  const COLOR_SELECTOR = 'input[name="front_order_line_item[color_id]"]'
  const COLOR_CODE_SELECTOR = 'input[name="front_order_line_item[color_code]"]'
  const SYSTEM_SELECTOR =
    'input[name="front_order_line_item[front_attributes][system_id]"]'
  const TYPE_SELECTOR =
    'input[name="front_order_line_item[front_attributes][type_id]"]'
  const FEATURE_SELECTOR = 'input[name="front_order_line_item[feature_id]"]'
  const TEXTURE_SELECTOR =
    'input[name="front_order_line_item[front_attributes][texture_id]"]'
  const SIZE_SELECTOR =
    'input[name="front_order_line_item[front_attributes][size_id]"]'
  const WIDTH_SELECTOR = 'input[type="radio"][name="size[width]"]'
  const HEIGHT_SELECTOR = 'input[type="radio"][name="size[height]"]'
  const FEATURE_CONTAINER_SELECTOR = ".-features"
  const HANDLE_SELECTOR = 'input[name="front_order_line_item[handle_id]"]'
  const HANDLE_CONTAINER_SELECTOR = ".-handles"
  const SUBMIT_SELECTOR = 'button[type="submit"]'
  const TOGGLE_COLOR_SELECTOR = ".-toggle-color"
  const COLOR_STANDARD_SELECTOR = ".-color-standard"
  const COLOR_CUSTOM_SELECTOR = ".-color-custom"
  const CUSTOM_WIDTH_SELECTOR =
    'input[name="front_order_line_item[custom_width]"]'
  const CUSTOM_WIDTH_CONTAINER_SELECTOR = ".-custom-width"
  const CUSTOM_HEIGHT_SELECTOR =
    'input[name="front_order_line_item[custom_height]"]'
  const CUSTOM_HEIGHT_CONTAINER_SELECTOR = ".-custom-height"
  const INVALID_SELECTOR = ".-configurator-invalid"
  const VALID_SELECTOR = ".-configurator-valid"

  const initializeColorSelect = () => {
    const selects = document.querySelectorAll(".color-select__input")

    selects.forEach((select) => {
      const wrapper = select.closest(".color-select__wrapper")

      // Create custom select elements
      const customSelect = document.createElement("div")
      const selectedDisplay = document.createElement("div")
      const optionsContainer = document.createElement("div")

      customSelect.className = "color-select__custom"
      selectedDisplay.className = "color-select__selected"
      optionsContainer.className = "color-select__options"

      // Create options
      Array.from(select.options).forEach((option) => {
        // Skip disabled options in the dropdown list
        if (option.disabled) {
          return
        }

        const optionElement = document.createElement("div")
        optionElement.className = "color-select__option"
        optionElement.dataset.codename = option.text

        const icon = document.createElement("img")
        icon.src = option.dataset.icon
        icon.alt = option.text

        optionElement.appendChild(icon)
        const text = document.createElement("span")
        text.appendChild(document.createTextNode(option.text))
        optionElement.appendChild(text)

        optionElement.addEventListener("click", () => {
          select.value = option.value
          updateSelected()
          // Hide options and remove open state
          optionsContainer.style.display = "none"
          selectedDisplay.classList.remove("is-open")
          select.dispatchEvent(new Event("change"))

          document.querySelector(COLOR_CODE_SELECTOR).value = option.text
          unlockSubmitButton()
        })

        optionsContainer.appendChild(optionElement)
      })

      const updateSelected = () => {
        const selectedOption = select.options[select.selectedIndex]
        selectedDisplay.innerHTML = ""
        const text = document.createElement("span")
        text.appendChild(document.createTextNode(selectedOption.text))

        if (selectedOption.disabled) {
          // If it's the placeholder option, don't show an icon
          selectedDisplay.appendChild(text)
        } else {
          const icon = document.createElement("img")
          icon.src = selectedOption.dataset.icon
          icon.alt = selectedOption.text

          selectedDisplay.appendChild(icon)
          selectedDisplay.appendChild(text)
        }
      }

      // Initial selected value
      updateSelected()

      // Toggle options with expanded view
      selectedDisplay.addEventListener("click", () => {
        const isVisible = optionsContainer.style.display === "block"
        if (isVisible) {
          optionsContainer.style.display = "none"
          selectedDisplay.classList.remove("is-open")
        } else {
          optionsContainer.style.display = "block"
          selectedDisplay.classList.add("is-open")
        }
      })

      // Close when clicking outside
      document.addEventListener("click", (e) => {
        if (!wrapper.contains(e.target)) {
          optionsContainer.style.display = "none"
          selectedDisplay.classList.remove("is-open")
        }
      })

      // Reset when 'ColorSwitched' event is triggered
      document.addEventListener("ColorSwitched", () => {
        select.value = ""
        document.querySelector(COLOR_CODE_SELECTOR).value = ""
        updateSelected()
        optionsContainer.style.display = "none"
        selectedDisplay.classList.remove("is-open")
      })

      // Add elements to DOM
      customSelect.appendChild(selectedDisplay)
      customSelect.appendChild(optionsContainer)
      wrapper.appendChild(customSelect)
    })

    // Initialize with any existing color code
    const colorCode = $(COLOR_CODE_SELECTOR).val()
    const selectOptions = $(".color-select__options .color-select__option")

    // Search for select option and click it
    selectOptions.each(function () {
      if ($(this)[0].dataset.codename === colorCode) {
        $(this).click()
      }
    })
  }

  function selectCollectionByCurrentColor() {
    const colorId = parseInt($(COLOR_SELECTOR + ":checked").val())
    const collectionsForColor = _.filter(collections, (collection) =>
      _.includes(collection["colorIds"], colorId),
    )

    if (collectionsForColor.length === 1) {
      selectCollection(collectionsForColor[0].id)
    }
  }

  function selectCollection(id) {
    $(COLLECTION_SELECTOR + '[value="' + id + '"]').prop("checked", true)
  }

  function filterForm() {
    selectCollectionByCurrentColor()

    const $systemInput = $(SYSTEM_SELECTOR + ":checked")
    const systemId = parseInt($systemInput.val())

    const collectionId = parseInt($(COLLECTION_SELECTOR + ":checked").val())
    const currentCollection = _.find(
      collections,
      (collection) => collection.id === collectionId,
    )

    const availableColorIds = getActiveIds(
      getFilteredFronts({ systemId }),
      "colorIds",
      true,
    )

    const isCustomSelectorVisible =
      $(COLOR_CUSTOM_SELECTOR).not(".hidden").length > 0

    const intersectedColorIds =
      currentCollection && isCustomSelectorVisible
        ? _.intersection(availableColorIds, currentCollection.colorIds)
        : availableColorIds

    const isDrawersSystem = $systemInput.data("codename") === "drawers"

    const colorIdsAfterSystem = isDrawersSystem
      ? colorsForDrawersIds
      : intersectedColorIds

    filterInputs(COLOR_SELECTOR, colorIdsAfterSystem)

    if (isDrawersSystem) {
      $(COLOR_SELECTOR + `[value="${colorsForDrawersIds[0]}"]`).prop(
        "checked",
        true,
      )
    }

    const customColors = $(COLOR_CUSTOM_SELECTOR)
      .find(".-color-custom-item")
      .not(".hidden")

    if (customColors.length === 0) {
      $(COLOR_CUSTOM_SELECTOR).addClass("hidden")
      $(COLOR_STANDARD_SELECTOR).removeClass("hidden")
      $(TOGGLE_COLOR_SELECTOR).parent().addClass("hidden")
    } else {
      $(TOGGLE_COLOR_SELECTOR).parent().removeClass("hidden")

      const selectedCustomColor = $(COLOR_SELECTOR + ":checked").data(
        "codename",
      )
      if (selectedCustomColor === "fropt-color") {
        $(".standard-color-input").addClass("hidden")
        $("#minimum_custom_color_order").addClass("hidden")
        $(".fropt-color-select").removeClass("hidden")
      }
    }

    if ($systemInput.data("codename") === "furniture-collection") {
      $(COLOR_CUSTOM_SELECTOR).addClass("hidden")
      $(COLOR_STANDARD_SELECTOR).removeClass("hidden")
      $(TOGGLE_COLOR_SELECTOR).parent().addClass("hidden")
    }

    const colorId = parseInt($(COLOR_SELECTOR + ":checked").val())

    if ($systemInput.length === 1) {
      if ($systemInput.data("codename") === "furniture-collection") {
        $("[data-system]").hide()
        $('[data-system="furniture-collection"]').show()
        $('[data-system="drawers"]').hide()
      } else {
        $("[data-system]").show()
        $('[data-system="furniture-collection"]').hide()
        $('[data-system="drawers"]').hide()
      }
    }

    if (isDrawersSystem) {
      $("[data-system]").hide()
      $('[data-system="furniture-collection"]').hide()
      $('[data-system="drawers"]').show()
    } else {
      $("[data-system]").show()
      $('[data-system="furniture-collection"]').hide()
      $('[data-system="drawers"]').hide()
    }

    const availableModelIds = getActiveIds(
      getFilteredFronts({ systemId, colorId, collectionId }),
      "modelId",
    )

    filterInputs(MODEL_SELECTOR, availableModelIds)

    const modelId = parseInt($(MODEL_SELECTOR + ":checked").val())

    filterInputs(
      TYPE_SELECTOR,
      getActiveIds(getFilteredFronts({ systemId, colorId, modelId }), "typeId"),
    )
    const typeId = parseInt($(TYPE_SELECTOR + ":checked").val())

    const availableFeatureIds = getActiveIds(
      getFilteredFronts({ systemId, colorId, modelId, typeId }),
      "featureIds",
      true,
    )

    filterInputs(FEATURE_SELECTOR, availableFeatureIds)
    const featureId = parseInt($(FEATURE_SELECTOR + ":checked").val())

    const availableTextureIds = getActiveIds(
      getFilteredFronts({ systemId, colorId, modelId, typeId, featureId }),
      "textureId",
    )
    const intersectedTextureIds = currentCollection
      ? _.intersection(availableTextureIds, currentCollection.textureIds)
      : availableTextureIds

    filterInputs(TEXTURE_SELECTOR, intersectedTextureIds)

    const textureId = parseInt($(TEXTURE_SELECTOR + ":checked").val())

    filterSizes(
      getActiveIds(
        getFilteredFronts({
          systemId,
          colorId,
          modelId,
          typeId,
          featureId,
          textureId,
        }),
        "sizeId",
      ),
    )

    const sizeId = parseInt($(SIZE_SELECTOR + ":checked").val())
    filterInputs(
      HANDLE_SELECTOR,
      getActiveIds(
        getFilteredFronts({
          systemId,
          colorId,
          modelId,
          typeId,
          featureId,
          textureId,
          sizeId,
        }),
        "handleIds",
        true,
      ),
    )

    calculatePrice()
    unlockSubmitButton()
  }

  function getFilteredFronts({
    systemId,
    collectionId,
    colorId,
    modelId,
    typeId,
    featureId,
    textureId,
    sizeId,
    handleId,
  }) {
    return _.filter(
      fronts,
      (front) =>
        (systemId ? front.systemId === systemId : true) &&
        (colorId
          ? systemId === drawerSystemId || _.includes(front.colorIds, colorId) // drawers do not have models, hence why we need to make exception
          : true) &&
        (collectionId ? _.includes(front.collectionIds, collectionId) : true) &&
        (modelId
          ? (modelId === -1 && front.modelId === null) ||
            front.modelId === modelId
          : true) &&
        (typeId ? front.typeId === typeId : true) &&
        (featureId && featureId !== -1
          ? _.includes(front.featureIds, featureId)
          : true) &&
        (textureId
          ? (textureId === -1 && front.textureId === null) ||
            front.textureId === textureId
          : true) &&
        (sizeId ? front.sizeId === sizeId : true) &&
        (handleId && handleId !== -1
          ? _.includes(front.handleIds, handleId)
          : true),
    )
  }

  function getActiveIds(filteredFronts, index, isCollection) {
    const filteredIds = _.map(filteredFronts, index)

    if (isCollection) {
      return _.uniq([].concat.apply([], filteredIds))
    }

    return _.uniq(filteredIds)
  }

  function filterInputs(selector, activeIds) {
    const $inputs = $(selector)
    const $sectionContainer = $inputs.closest(".BorderedBox__list__item")
    let hiddenInputsLength = 0

    _.each($inputs, (input) => {
      const $input = $(input)
      const $inputContainer = $input.closest(".TiledList__item")
      const $sectionContainer = $input.closest(".BorderedBox__list__section")

      if (_.includes(activeIds, parseInt($input.val()))) {
        $inputContainer.removeClass("hidden")
      } else {
        $inputContainer.addClass("hidden")
        $input.prop("checked", false)
        hiddenInputsLength++
      }

      if (
        $sectionContainer.find(".TiledList__item.hidden").length ===
        $sectionContainer.find(".TiledList__item").length
      ) {
        $sectionContainer.addClass("hidden")
      } else {
        $sectionContainer.removeClass("hidden")
      }
    })

    if ($inputs.length === hiddenInputsLength) {
      $sectionContainer.addClass("hidden")
    } else {
      $sectionContainer.removeClass("hidden")

      if (
        $(selector + ":checked").length === 0 &&
        $(selector + '[data-default="true"]').length === 1 &&
        $(selector + '[data-default="true"]')
          .closest(".TiledList__item")
          .hasClass("hidden") !== true
      ) {
        $(selector + '[data-default="true"]').prop("checked", true)
      }
    }
  }

  function filterSizes(activeIds) {
    const $sizeInputs = _.filter($(SIZE_SELECTOR), (sizeInput) =>
      _.includes(activeIds, parseInt($(sizeInput).val())),
    )

    const widths = new Set()
    const heights = new Set()

    $sizeInputs.forEach((input) => {
      const $input = $(input)
      widths.add(String($input.data("width")))
      heights.add(String($input.data("height")))
    })

    const widthValues = Array.from(widths.values())
    const heightValues = Array.from(heights.values())

    const widthSelector = _.find($(WIDTH_SELECTOR), (widthInput) => {
      const components = String($(widthInput).data("components")).split("|")

      return widthValues.every((entry) => components.includes(entry))
    })

    if (widthSelector) {
      $(widthSelector).prop("checked", true)
    }

    const heightSelector = _.find($(HEIGHT_SELECTOR), (heightInput) => {
      const components = String($(heightInput).data("components")).split("|")

      return heightValues.every((entry) => components.includes(entry))
    })

    if (heightSelector) {
      $(heightSelector).prop("checked", true)
    }

    if (heightValues.length === 1 && heightValues.includes("")) {
      $(".height-container").hide()
    } else {
      $(".height-container").show()
    }

    let $selectedWidthInput = $(WIDTH_SELECTOR + ":checked")
    const selectedWidthComponents = (
      $selectedWidthInput.data("components") || ""
    )
      .toString()
      .split("|")
    let $selectedHeightInput = $(HEIGHT_SELECTOR + ":checked")
    const selectedHeightComponents = (
      $selectedHeightInput.data("components") || ""
    )
      .toString()
      .split("|")

    _.each($(WIDTH_SELECTOR + ", " + HEIGHT_SELECTOR), (input) => {
      $(input).closest(".TiledList__item").addClass("hidden")
    })

    let minWidth = Number.POSITIVE_INFINITY
    let maxWidth = Number.NEGATIVE_INFINITY
    let minHeight = Number.POSITIVE_INFINITY
    let maxHeight = Number.NEGATIVE_INFINITY

    _.each($sizeInputs, (input) => {
      const $input = $(input)

      const width = String($input.data("width"))
      const $widthInput = $(
        _.find($(WIDTH_SELECTOR), (widthInput) =>
          _.includes(
            $(widthInput).data("components").toString().split("|"),
            width,
          ),
        ),
      )

      $widthInput.closest(".TiledList__item").removeClass("hidden")

      const splittedWidth = width.split("-")

      if (parseFloat(splittedWidth[0]) < minWidth) {
        minWidth = parseFloat(splittedWidth[0])
      }

      if (splittedWidth[1] && parseFloat(splittedWidth[1]) > maxWidth) {
        maxWidth = parseFloat(splittedWidth[1])
      }

      if (
        !selectedWidthComponents ||
        _.includes(selectedWidthComponents, width)
      ) {
        const height = String($input.data("height"))
        const $heightInput = $(
          _.find($(HEIGHT_SELECTOR), (heightInput) =>
            _.includes(
              $(heightInput).data("components").toString().split("|"),
              height,
            ),
          ),
        )
        $heightInput.closest(".TiledList__item").removeClass("hidden")

        const splittedHeight = height.split("-")

        if (parseFloat(splittedHeight[0]) < minHeight) {
          minHeight = parseFloat(splittedHeight[0])
        }

        if (splittedHeight[1] && parseFloat(splittedHeight[1]) > maxHeight) {
          maxHeight = parseFloat(splittedHeight[1])
        }
      }
    })

    let selectedWidth
    let selectedHeight

    const widthLabel = minWidth + "-" + maxWidth
    const heightLabel = minHeight + "-" + maxHeight
    $(WIDTH_SELECTOR + '[value="custom"] + label').html(
      `<span>${widthLabel}</span>`,
    )
    $(HEIGHT_SELECTOR + '[value="custom"] + label').html(
      `<span>${heightLabel}</span>`,
    )

    if ($selectedWidthInput.val() === "custom") {
      $(CUSTOM_WIDTH_CONTAINER_SELECTOR).removeClass("hidden")

      if (
        parseFloat($(CUSTOM_WIDTH_SELECTOR).val()) < minWidth ||
        parseFloat($(CUSTOM_WIDTH_SELECTOR).val()) > maxWidth
      ) {
        $(CUSTOM_WIDTH_SELECTOR).val("")
      }

      $(CUSTOM_WIDTH_SELECTOR).data("min", minWidth).data("max", maxWidth)
      $(CUSTOM_WIDTH_SELECTOR + " + label").text(
        $(CUSTOM_WIDTH_SELECTOR).data("label") + ": " + widthLabel,
      )

      selectedWidth = $(CUSTOM_WIDTH_SELECTOR).val()
    } else {
      $(CUSTOM_WIDTH_CONTAINER_SELECTOR).addClass("hidden")
      selectedWidth = $selectedWidthInput.val()
    }

    if ($selectedHeightInput.val() === "custom") {
      $(CUSTOM_HEIGHT_CONTAINER_SELECTOR).removeClass("hidden")

      if (
        parseFloat($(CUSTOM_HEIGHT_SELECTOR).val()) < minHeight ||
        parseFloat($(CUSTOM_HEIGHT_SELECTOR).val()) > maxHeight
      ) {
        $(CUSTOM_HEIGHT_SELECTOR).val("")
      }

      $(CUSTOM_HEIGHT_SELECTOR).data("min", minHeight).data("max", maxHeight)
      $(CUSTOM_HEIGHT_SELECTOR + " + label").text(
        $(CUSTOM_HEIGHT_SELECTOR).data("label") + ": " + heightLabel,
      )

      selectedHeight = $(CUSTOM_HEIGHT_SELECTOR).val()
    } else {
      $(CUSTOM_HEIGHT_CONTAINER_SELECTOR).addClass("hidden")
      selectedHeight = $selectedHeightInput.val()
    }

    const selectedSizeInput = _.find($sizeInputs, (sizeInput) => {
      const $sizeInput = $(sizeInput)

      const roundedSelectedWidth = Math.floor(selectedWidth)
      const inputWidth = String($sizeInput.data("width"))
      const inputWidthFrom = parseFloat($sizeInput.data("width-from"))
      const inputWidthTo = parseFloat($sizeInput.data("width-to"))

      const isWidthMatched =
        _.includes(selectedWidthComponents, inputWidth) &&
        inputWidthFrom <= roundedSelectedWidth &&
        inputWidthTo >= roundedSelectedWidth

      if (!isWidthMatched) {
        return false
      }

      const roundedSelectedHeight = Math.floor(selectedHeight)
      const inputHeight = String($sizeInput.data("height"))
      const inputHeightFrom = parseFloat($sizeInput.data("height-from"))
      const inputHeightTo = parseFloat($sizeInput.data("height-to"))

      if (!_.includes(selectedHeightComponents, inputHeight)) {
        return false
      }

      if (inputHeight === "" || inputHeightFrom === inputHeightTo) {
        return true
      }

      return (
        inputHeightFrom <= roundedSelectedHeight &&
        inputHeightTo >= roundedSelectedHeight
      )
    })

    let $selectedSizeInput = $(selectedSizeInput)
    $selectedSizeInput.prop("checked", true)

    $selectedSizeInput = $(SIZE_SELECTOR + ":checked")

    if (
      $selectedWidthInput.length !== 0 &&
      $selectedWidthInput.closest(".TiledList__item").hasClass("hidden")
    ) {
      $selectedWidthInput.prop("checked", false)
      $(SIZE_SELECTOR + ":checked").prop("checked", false)
      $(CUSTOM_WIDTH_CONTAINER_SELECTOR).addClass("hidden")
    } else if (
      $selectedWidthInput.length === 0 &&
      $selectedSizeInput.length !== 0
    ) {
      const selectedWidthInput = _.find($(WIDTH_SELECTOR), (widthInput) =>
        _.includes(
          $(widthInput).data("components").toString().split("|"),
          $selectedSizeInput.data("width"),
        ),
      )

      $selectedWidthInput = $(selectedWidthInput)
      $selectedWidthInput.prop("checked", true).trigger("change")
    }

    if (
      $selectedHeightInput.length !== 0 &&
      $selectedHeightInput.closest(".TiledList__item").hasClass("hidden")
    ) {
      $selectedHeightInput.prop("checked", false)
      $(SIZE_SELECTOR + ":checked").prop("checked", false)
      $(CUSTOM_HEIGHT_CONTAINER_SELECTOR).addClass("hidden")
    } else if (
      $selectedHeightInput.length === 0 &&
      $selectedSizeInput.length !== 0
    ) {
      const selectedHeightInput = _.find($(HEIGHT_SELECTOR), (heightInput) =>
        _.includes(
          $(heightInput).data("components").toString().split("|"),
          $selectedSizeInput.data("height"),
        ),
      )

      $selectedHeightInput = $(selectedHeightInput)
      $selectedHeightInput.prop("checked", true).trigger("change")
    }
  }

  function getCurrentProduct() {
    const modelId = parseInt($(MODEL_SELECTOR + ":checked").val() || -1)
    const colorId = parseInt($(COLOR_SELECTOR + ":checked").val() || -1)
    const systemId = parseInt($(SYSTEM_SELECTOR + ":checked").val() || -1)
    const typeId = parseInt($(TYPE_SELECTOR + ":checked").val() || -1)
    const featureId = parseInt($(FEATURE_SELECTOR + ":checked").val() || -1)
    const textureId = parseInt($(TEXTURE_SELECTOR + ":checked").val() || -1)
    const sizeId = parseInt($(SIZE_SELECTOR + ":checked").val() || -1)
    const handleId = parseInt($(HANDLE_SELECTOR + ":checked").val() || -1)

    const fronts = getFilteredFronts({
      systemId,
      colorId,
      modelId,
      typeId,
      featureId,
      textureId,
      sizeId,
      handleId,
    })

    return fronts[0]
  }

  function calculatePrice() {
    const front = getCurrentProduct()

    if (front) {
      const handlePrice = parseFloat(
        $(HANDLE_SELECTOR + ":checked").data("price") || 0,
      )
      const colorId = parseInt($(COLOR_SELECTOR + ":checked").val() || -1)
      const colorPrice = _.find(front.colorPrices, (colorItem) =>
        _.includes(colorItem.color_ids, colorId),
      )

      const price =
        parseFloat(front[`price_${currency}`]) +
        handlePrice +
        (colorPrice ? parseFloat(colorPrice[`price_${currency}`]) : 0)
      const quantity = $('input[name="front_order_line_item[quantity]"]').val()

      $(".AmountPrice__price").text(`${price * quantity} ${currencyLabel}`)
    } else {
      $(".AmountPrice__price").text("-")
    }
  }

  function unlockSubmitButton() {
    const $submitButton = $(SUBMIT_SELECTOR)
    const front = getCurrentProduct()

    const customColorSelected =
      $(COLOR_SELECTOR + '[data-custom="true"]:checked').length === 1
    const colorCodeFilled = ($(COLOR_CODE_SELECTOR).val() || "").length > 0
    const featureEnabled =
      $(FEATURE_CONTAINER_SELECTOR).hasClass("hidden") !== true
    const featureSelected = $(FEATURE_SELECTOR + ":checked").length === 1
    const handleEnabled =
      $(HANDLE_CONTAINER_SELECTOR).hasClass("hidden") !== true
    const handleSelected = $(HANDLE_SELECTOR + ":checked").length === 1

    const customWidthSelected =
      $(WIDTH_SELECTOR + '[data-custom="true"]:checked').length === 1
    const customWidthFilled = $(CUSTOM_WIDTH_SELECTOR).val().length > 0
    const customHeightSelected =
      $(HEIGHT_SELECTOR + '[data-custom="true"]:checked').length === 1
    const customHeightFilled = $(CUSTOM_HEIGHT_SELECTOR).val().length > 0

    if (
      front &&
      (!customColorSelected || colorCodeFilled) &&
      (!featureEnabled || featureSelected) &&
      (!handleEnabled || handleSelected) &&
      (!customWidthSelected || customWidthFilled) &&
      (!customHeightSelected || customHeightFilled)
    ) {
      $(INVALID_SELECTOR).addClass("hidden")
      $(VALID_SELECTOR).removeClass("hidden")
      $submitButton.prop("disabled", false)
    } else {
      $(INVALID_SELECTOR).removeClass("hidden")
      $(VALID_SELECTOR).addClass("hidden")
      $submitButton.prop("disabled", true)
    }
  }

  function scrollToSectionIfNeeded($element) {
    const sectionOffset = $element.offset().top
    const scrollOffset = $(window).scrollTop()
    const headerHeight = $("#header_and_notification").height() || 0
    const newScrollOffset = sectionOffset - headerHeight

    if (scrollOffset > newScrollOffset) {
      $("html, body").animate(
        {
          scrollTop: newScrollOffset,
        },
        0,
      )
    }
  }

  window.addEventListener("DOMContentLoaded", () => {
    if ($("#configurator").length === 0) {
      return
    }

    $(".BorderedBox__list__item").on("change", "input[type=radio]", (e) => {
      filterForm()
    })

    $(".AmountPrice__amount__minus").on("click", (e) => {
      const $quantity = $('input[name="front_order_line_item[quantity]"]')
      const newVal = parseInt($quantity.val()) - 1
      $quantity.val(newVal <= 0 ? 1 : newVal)

      calculatePrice()
    })

    $(".AmountPrice__amount__plus").on("click", (e) => {
      const $quantity = $('input[name="front_order_line_item[quantity]"]')
      $quantity.val(parseInt($quantity.val()) + 1)

      calculatePrice()
    })

    $('input[name="front_order_line_item[quantity]"]').on(
      "change",
      function (e) {
        $(this).val(
          $(this)
            .val()
            .replace(/[^0-9.]/g, ""),
        )

        if ($(this).val() <= 0) {
          $(this).val(1)
        }

        calculatePrice()
      },
    )

    $(COLOR_SELECTOR).on("change", function (e) {
      const $selectedColor = $(this)
      const isFroptColor = $selectedColor.data("codename") === "fropt-color"
      const isCustomToggle = $selectedColor.hasClass("-toggle-color")

      if (isCustomToggle) {
        e.preventDefault()

        $(COLOR_CUSTOM_SELECTOR).removeClass("hidden")
        $(COLOR_STANDARD_SELECTOR).addClass("hidden")
        // Clear both inputs when toggling to custom colors
        $('input[name="front_order_line_item[color_code]"]').val("")
        $(".color-select__input").val("").trigger("change")

        selectCollection($selectedColor.data("collection-id"))
        filterForm()

        scrollToSectionIfNeeded(
          $(COLOR_CUSTOM_SELECTOR).closest(".BorderedBox__list__item"),
        )

        return
      }

      if (isFroptColor) {
        $(".standard-color-input").addClass("hidden")
        $("#minimum_custom_color_order").addClass("hidden")
        $(".fropt-color-select").removeClass("hidden")
        // Clear standard input when switching to custom select
        $('input[name="front_order_line_item[color_code]"]').val("")
      } else {
        $(".standard-color-input").removeClass("hidden")
        $("#minimum_custom_color_order").removeClass("hidden")
        $(".fropt-color-select").addClass("hidden")
      }

      document.dispatchEvent(new Event("ColorSwitched"))

      calculatePrice()
      unlockSubmitButton()
    })

    $(COLOR_CODE_SELECTOR).on("input", (e) => {
      unlockSubmitButton()
    })

    $(".-toggle-color").on("click", function (e) {
      if ($(this).is("a")) {
        // Only for the "back to color" link
        e.preventDefault()

        // Clear both inputs when going back to standard colors
        $('input[name="front_order_line_item[color_code]"]').val("")
        $(".color-select__input").val("").trigger("change")
        $(COLOR_CUSTOM_SELECTOR).addClass("hidden")
        $(COLOR_STANDARD_SELECTOR).removeClass("hidden")
        $(COLOR_SELECTOR + ":checked").prop("checked", false)

        filterForm()

        scrollToSectionIfNeeded(
          $(COLOR_STANDARD_SELECTOR).closest(".BorderedBox__list__item"),
        )
      }

      calculatePrice()
      unlockSubmitButton()
    })

    $(CUSTOM_WIDTH_SELECTOR + ", " + CUSTOM_HEIGHT_SELECTOR).on(
      "change",
      function (e) {
        const $element = $(this)
        const min = parseFloat($element.data("min"))
        const max = parseFloat($element.data("max"))

        if (parseFloat($element.val()) < min) {
          $element.val(min)
        }

        if (parseFloat($element.val()) > max) {
          $element.val(max)
        }

        filterForm()
      },
    )

    initializeColorSelect()

    filterForm()
  })
})()
